
export const FETCH_DELIVERY_FEES_START = "FETCH_DELIVERY_FEES_START";
export const FETCH_DELIVERY_FEES_SUCCESS = "FETCH_DELIVERY_FEES_SUCCESS";
export const FETCH_DELIVERY_FEES_ERROR = "FETCH_DELIVERY_FEES_ERROR";